import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  lastValueFrom,
} from 'rxjs';
import { DTO, Types } from 'shared-lib';
import { LibRXDBDatabaseService } from '../../service/database/rxdb.database.service';

@Injectable({
  providedIn: 'root',
})
export class UploadService {
  constructor(
    private http: HttpClient,
    private databaseService: LibRXDBDatabaseService
  ) {}

  async readOne(id: Types.TChoice | undefined) {
    try {
      await this.databaseService.initDb();
      const imageCacheModel = await this.databaseService.readOne<
        string,
        DTO.DownloadDTO
      >(`image_cache`, id);
      if (imageCacheModel) {
        const imageCache = new DTO.DownloadDTO();
        imageCache.id = imageCacheModel.id;
        imageCache.base64 = imageCacheModel.base64;
        imageCache.eTag = '';
        imageCache.mimetype = imageCacheModel.mimetype;
        imageCache.name = imageCacheModel.name;
        imageCache.originalname = imageCacheModel.originalname;
        imageCache.size = imageCacheModel.size;
        return imageCache;
      }
      const response = await lastValueFrom(
        this.http.get<DTO.DownloadDTO | false>(`files/${id}`)
      );
      if (!response) {
        return;
      }
      await this.databaseService.create<string, DTO.DownloadDTO>(
        `image_cache`,
        response
      );
      return response;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  async uploadOne(file: File) {
    try {
      await this.databaseService.initDb();
      const formData = new FormData();
      formData.append('file', file);
      const reader = new FileReader();
      let base64Image = '';
      reader.onload = (e) => {
        base64Image = e.target?.result as string;
      };
      reader.readAsDataURL(file);
      const response = await lastValueFrom(
        this.http.patch<DTO.UploadDTO>('files/upload', formData)
      );
      const imageCache = new DTO.DownloadDTO();
      imageCache.id = response.id;
      imageCache.base64 = base64Image;
      imageCache.eTag = '';
      imageCache.mimetype = response.mimetype ?? '';
      imageCache.name = response.name  ?? '';
      imageCache.originalname = response.originalname  ?? '';
      imageCache.size = response.size ?? 0;
      await this.databaseService.create<string, DTO.DownloadDTO>(
        `image_cache`,
        imageCache
      );
      return response;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  async deleteOne(id?: Types.TChoice) {
    try {
      await this.databaseService.initDb();
      return lastValueFrom(this.http.delete<boolean>(`files/${id}`));
    } catch (error) {
      console.error(error);
      return false;
    }
  }
}
